import dynamic from 'next/dynamic';
import { isBlogRoute } from '@/utils/route-detection';

// Blog-specific components (lightweight)
export const blogComponents = {
  blog_home_component_selector: dynamic(
    () => import('./BlogHomeComponentSelector'),
  ),
  hero_with_bullet_points: dynamic(() => import('./HeroWithBulletPoints')),
  call_to_action: dynamic(() => import('./CallToAction')),
  rich_text: dynamic(() => import('./RichText')),
  news_letter: dynamic(() => import('./NewsLetter')),
  social_media: dynamic(() => import('./SocialMedia')),
  submenu: dynamic(() => import('./Submenu')),
};

// Full components for all other pages
export const fullComponents = {
  achievments: dynamic(() => import('./Achievements')),
  avatar_grid: dynamic(() => import('./AvatarGrid')),
  benefits: dynamic(() => import('./Benefits')),
  blog_home_component_selector: dynamic(
    () => import('./BlogHomeComponentSelector'),
  ),
  calendar: dynamic(() => import('./Calendar')),
  call_to_action: dynamic(() => import('./CallToAction')),
  card_grid: dynamic(() => import('./JobPostCardGrid')),
  cards_comparison: dynamic(() => import('./CardsComparison')),
  cards_grid: dynamic(() => import('./CardsGrid')),
  case_studies: dynamic(() => import('./CaseStudies')),
  challenge: dynamic(() => import('./Challenge')),
  clients_list: dynamic(() => import('./ClientsList')),
  comparison_table: dynamic(() => import('./ComparisonTable')),
  comparison_with_feature_diagram: dynamic(
    () => import('./ComparisonWithFeatureDiagram'),
  ),
  confirmation_banner: dynamic(() => import('./ConfirmationBanner')),
  content_visual_cta: dynamic(() => import('./ContentVisualCta')),
  content_with_media: dynamic(() => import('./ContentWithMedia')),
  cta_map_text: dynamic(() => import('./CtaSideImg')),
  cta_side_img: dynamic(() => import('./CtaSideImg')),
  core_values_grid: dynamic(() => import('./CoreValuesGrid')),
  cta_with_form: dynamic(() => import('./CtaWithForm')),
  description_card: dynamic(() => import('./DescriptionCard')),
  discount_header: dynamic(() => import('./LandingHeader')),
  expertise: dynamic(() => import('./Expertise')),
  faqs: dynamic(() => import('./Faqs')),
  feature_card_grid: dynamic(() => import('./GetStartedForm')),
  feature_columns_with_graphic: dynamic(
    () => import('./FeatureColumnsWithGraphic'),
  ),
  feature_highlight_split: dynamic(() => import('./FeatureHighlightSplit')),
  feature_highlight_with_cta: dynamic(
    () => import('./FeatureHighlightWithCta'),
  ),
  feature_overview_grid: dynamic(() => import('./FeatureOverviewGrid')),
  feature_with_highlighted_code: dynamic(
    () => import('./FeatureWithHighlightedCode'),
  ),
  featured_posts: dynamic(() => import('./FeaturedPosts')),
  features_list: dynamic(() => import('./FeaturesList')),
  five_image_cards: dynamic(() => import('./FiveImageCards')),
  form: dynamic(() => import('./Form')),
  form_with_background: dynamic(() => import('./FormWithBackground')),
  full_image_with_items: dynamic(() => import('./FullImageWithItems')),
  headline_centered_illustration: dynamic(
    () => import('./HeadlineCenteredAnimation'),
  ),
  headline_cta_centered: dynamic(() => import('./HeadlineCtaCentered')),
  headline_description_cta_steps: dynamic(
    () => import('./HeadlineDescriptionCtaSteps'),
  ),
  headline_features_cta: dynamic(() => import('./HeadlineFeaturesCta')),
  headline_with_highlights: dynamic(() => import('./HeadlineWithHighlights')),
  headline_with_illustration: dynamic(
    () => import('./HeadlineWithIllustrationVelx'),
  ),
  headline_with_stat_cards: dynamic(() => import('./HeadlineWithStatCards')),
  hero_card_header_subpages: dynamic(() => import('./HeroCardHeaderSubpages')),
  hero_clients: dynamic(() => import('./HeroClients')),
  hero_cta_with_logos: dynamic(() => import('./HeroCtaWithLogos')),
  hero_headline_cta: dynamic(() => import('./HeroHeadlineCtaWithBreadCrumbs')),
  hero_with_bullet_points: dynamic(() => import('./HeroWithBulletPoints')),
  hero_with_navigation: dynamic(() => import('./HeroForVelx')),
  hero_with_services_grid: dynamic(() => import('./SectionServicesGrid')),
  hero_with_trust_logos: dynamic(() => import('./HeroWithTrustLogos')),
  highlighted_card: dynamic(() => import('./HighlightedCard')),
  highlighted_cards_grid: dynamic(() => import('./HighlightedCardsGrid')),
  highlighted_job_listings: dynamic(() => import('./HighlightedJobListings')),
  image_select: dynamic(() => import('./ImageSelect')),
  image_with_form: dynamic(() => import('./ImageWithForm')),
  impact_highlights: dynamic(() => import('./ImpactHighlights')),
  info_columns: dynamic(() => import('./InfoColumns')),
  inputs: dynamic(() => import('./Inputs')),
  intro_media_grid: dynamic(() => import('./IntroMediaGrid')),
  leaders: dynamic(() => import('./Leaders')),
  logo_static: dynamic(() => import('./Logos')),
  logo_strip: dynamic(() => import('./LogoStrip')),
  media_text_grid: dynamic(() => import('./MediaTextGrid')),
  medium_white_card: dynamic(() => import('./MediumWhiteCard')),
  menu_link: dynamic(() => import('./MenuLink')),
  multi_tab: dynamic(() => import('./MultiTab')),
  news_letter: dynamic(() => import('./NewsLetter')),
  numbers: dynamic(() => import('./Numbers')),
  popup: dynamic(() => import('./Popup')),
  pricing_comparison_cards: dynamic(() => import('./PricingComparisonCards')),
  process_overview_cta: dynamic(() => import('./ProcessOverviewCta')),
  process_step: dynamic(() => import('./ProcessStep')),
  promotional_phrases_carousel: dynamic(
    () => import('./PromotionalPhrasesCarousel'),
  ),
  remote_work_image_and_button: dynamic(
    () => import('./RemoteWorkImageAndButton'),
  ),
  rich_text: dynamic(() => import('./RichText')),
  services: dynamic(() => import('./Services')),
  side_media_cta: dynamic(() => import('./SideMediaCta')),
  simple_case_study: dynamic(() => import('./CaseStudy')),
  social_media: dynamic(() => import('./SocialMedia')),
  solutions: dynamic(() => import('./Solutions')),
  stat_grid: dynamic(() => import('./StatGrid')),
  stats: dynamic(() => import('./Stats')),
  stats_with_logos: dynamic(() => import('./StatsWithLogos')),
  submenu: dynamic(() => import('./Submenu')),
  talent_feature_callout: dynamic(() => import('./TalentFeatureCallout')),
  team_leadership_grid: dynamic(() => import('./TeamLeadershipGrid')),
  team_members_grid: dynamic(() => import('./TeamMembersGrid')),
  testimonial_carousel: dynamic(() => import('./TestimonialCarousel')),
  testimonial_carousel_2: dynamic(() => import('./CaseStudiesCarousel')),
  testimonial_highlight: dynamic(() => import('./TestimonialHighlight')),
  testimonies_card: dynamic(() => import('./TestimoniesCard')),
  testimonies_carousel: dynamic(() => import('./TestimoniesCarousel')),
  timeline: dynamic(() => import('./Timeline')),
  timeline_2: dynamic(() => import('./Timeline2')),
  value_proposition_grid: dynamic(() => import('./ValuePropositionGrid')),
  values_grid: dynamic(() => import('./ValuesGrid')),
  video_header: dynamic(() => import('./VideoHeader')),
};

/**
 * Get components based on whether this is a blog page or not
 * @param isBlog - Whether this is a blog page (optional, will auto-detect if not provided)
 * @returns The appropriate components object
 */
export function getComponents(isBlog?: boolean) {
  // Auto-detect if not explicitly provided
  const shouldUseBlogComponents = isBlog ?? isBlogRoute();
  return shouldUseBlogComponents ? blogComponents : fullComponents;
}
